import React, { useEffect, useRef, useState } from 'react'
import Header from '../Header/Header.js'
import Footer from '../Footer/Footer.js'
import { GoCircle } from 'react-icons/go';
import { SlLocationPin } from 'react-icons/sl';
import { Link } from 'react-router-dom';
import { MdContentCopy, MdDirectionsBike } from 'react-icons/md';
import { BsBox } from 'react-icons/bs';
import { GET_ORDER_SAME_DAY } from '../graphql/Mutation/SameDayOrder.js';
import { useQuery } from '@apollo/client';
import { GET_ROLE_USER } from '../graphql/Query/Signin.js';
import { useModal } from '../Contex.js';
import NoDataFound from '../components/NoDataFound.js';
import SpinLoader from '../components/SpinLoader.js';
import moment from 'moment';
import MapWithRoute from './MapWithRoute.js';
import CustomPagination from '../components/Pagination.js';

const BikeAllOrder = () => {
    const mapRef = useRef(null);
    const [orderData, setOrderData] = useState([]);
    const { openModal, setModalOpen } = useModal();
    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(10);
    const [searchUser, setSearchUser] = useState('');
    const [toDate, setToDate] = useState('');
    const [filter, setFilter] = useState('');
    const [copySuccess, setCopySuccess] = useState({});
    const [fromDate, setFromDate] = useState('');
    const idData = localStorage.getItem('id');
    const [activeButton, setActiveButton] = useState('Bike Parcel');
    const { data: getUser, refetch: getUserRoleRefetch } = useQuery(GET_ROLE_USER);
    const { data, loading, refetch } = useQuery(GET_ORDER_SAME_DAY,
        {
            variables: {
                page: page + 1,
                limit,
                "sort": {
                    "key": "createdAt",
                    "type": -1
                },
                customerId: getUser?.me?.id || idData,
                tag: activeButton,
                "filter": filter,
                "from": fromDate,
                "to": toDate,
            },
            fetchPolicy: 'cache-and-network',

        });
    useEffect(() => {
        if (data?.getOrdersforSameDay?.data) {
            setOrderData(data?.getOrdersforSameDay?.data);
        }
    }, [data]);
    // console.log('✌️data --->', data);
    const fromDateChange = (e) => {
        setFromDate(e.target.value);
    }

    const toDateChange = (e) => {
        setToDate(e.target.value);
    }

    const handleSearch = (e) => {
        setFilter(searchUser);
        setPage(0);
    }

    const handleCopy = (awbNumber, index) => {
        // Use the Clipboard API to copy the text
        navigator.clipboard.writeText(awbNumber)
            .then(() => {
                setCopySuccess((prev) => ({
                    ...prev,
                    [index]: true,
                }));
                setTimeout(() => {
                    setCopySuccess((prev) => ({
                        ...prev,
                        [index]: false,
                    }));
                }, 2000);
            })
            .catch(err => {
                // console.error('Failed to copy text: ', err);
            });
    };
    const handleReset = () => {
        setFromDate('');
        setToDate('');
        setFilter('');
        setSearchUser('');
    }
    const handlePageClick = (selectedPage) => {
        setPage(selectedPage);
        refetch(); // Refetch data with the new page
    };
    return (
        <div>
            <Header />
            <div className="bg-white">
                <div>
                    <main className="mx-auto max-w-auto px-4 sm:px-6 lg:px-8">
                        <div className='p-4 mt-6 max-w-full mx-auto bg-slate-50 ring-1 ring-gray-200 rounded-xl space-y-4'>
                            <div className='flex justify-between '>
                                <div className='flex'>
                                    <MdDirectionsBike className='text-2xl me-3 text-gray-900 drop-shadow-xl' />
                                    <h1 className='font-bold'>In-City Bike Parcel Delivery Services</h1>
                                </div>

                                <div className='flex space-x-4'>
                                    <h2 className="hidden md:block font-semibold">Shipment Filter</h2>
                                    <p className="text-gray-400 inline-block font-normal mb-6 underline decoration-dashed underline-offset-8 cursor-pointer" onClick={handleReset}>Reset</p>
                                </div>

                            </div>
                            <div className='lg:flex space-y-2 lg:space-y-0 lg:justify-between'>
                                <div>
                                    <p className="text-sm font-medium text-gray-700">Search</p>
                                    <div className='md:flex md:space-x-4 space-x-0'>
                                        <div>
                                            <input type="text"
                                                onChange={(e) => setSearchUser(e.target.value)} onKeyDown={handleSearch} value={searchUser}
                                                placeholder="Search..." className="mt-1 focus:ring-0 focus:ring-inset focus:outline-none focus:ring-slate-600 focus:border-slate-600 mb-2 md:mb-0 w-full md:w-none  px-2 py-1 border rounded-md" />
                                        </div>
                                    </div>
                                </div>
                                <div className='md:flex md:space-x-4 space-x-0 space-y-3 md:space-y-0'>
                                    <div className='cursor-pointer'>
                                        <p className="text-sm font-medium text-gray-700">From</p>
                                        <div className='md:flex md:space-x-4 space-x-0'>
                                            <input
                                                type="date"
                                                className="mt-1 w-full md:w-none  px-2 py-1.5 md:py-1  focus:ring-0 focus:ring-inset focus:outline-none focus:ring-slate-600 focus:border-slate-600 border rounded-md cursor-pointer"
                                                value={fromDate}
                                                onChange={(e) => { fromDateChange(e) }}
                                            />
                                        </div>
                                    </div>
                                    <div>
                                        <p className="text-sm font-medium text-gray-700">To</p>
                                        <div className='md:flex md:space-x-4 space-x-0 '>
                                            <div>
                                                <input
                                                    type="date"
                                                    className="mt-1 cursor-pointer focus:ring-0 focus:ring-inset focus:outline-none focus:ring-slate-600 focus:border-slate-600 mb-2 md:mb-0 w-full md:w-none  px-2 py-1.5 md:py-1 border rounded-md"
                                                    value={toDate}

                                                    onChange={(e) => toDateChange(e)}
                                                />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <section aria-labelledby="products-heading" className="pb-2 lg:pt-6">
                            <h2 id="products-heading" className="sr-only">
                                Products
                            </h2>

                            <div className="grid grid-cols-1 gap-x-8 gap-y-10 lg:grid-cols-4">
                                <div className="space-y-4 pb-6 text-sm font-medium text-gray-900">
                                    <div className=' hidden lg:block py-3 bg-slate-50 rounded-lg px-4 cursor-pointer'>
                                        <section className="mb-8">
                                            <h2 className="text-lg font-semibold mb-2">"To Me"</h2>
                                            <p className="mb-4 text-slate-700 font-normal">
                                                <strong className='text-slate-800 font-semibold'>Meaning:</strong> When a shipment is labeled "To Me," it means that the shipment is being sent to you.
                                                Someone else (the sender) has created an order or package and is shipping it to your address.
                                            </p>
                                            <p className="mb-4 text-slate-700 font-normal">
                                                <strong className='text-slate-800 font-semibold'>Example:</strong> If you order a product online and the seller sends the package to your home or office,
                                                that shipment is "To Me." You are the recipient of the Shipment.
                                            </p>
                                        </section>

                                        <section className="mb-8">
                                            <h2 className="text-lg font-semibold mb-2">"From Me"</h2>
                                            <p className="mb-4 text-slate-700 font-normal">
                                                <strong className='text-slate-800 font-semibold'>Meaning:</strong> When a shipment is labeled "From Me," it means that you are the one sending the shipment
                                                to someone else. You create the order, prepare the package, and arrange for the Shipment to deliver it to the recipient.
                                            </p>
                                            <p className="mb-4 text-slate-700 font-normal">
                                                <strong className='text-slate-800 font-semibold'>Example:</strong> If you need to send a document to a client or a package to a friend, you create the
                                                shipment, label it, and the Shipment delivers it to the recipient. In this case, the shipment is "From Me."
                                            </p>
                                        </section>

                                        <section className="mb-8">
                                            <h2 className="text-lg font-semibold mb-2">Application in a Shipment Business</h2>
                                            <ul className="list-disc pl-6 space-y-2">
                                                <li className="text-slate-700 font-normal"><strong className='text-slate-800 font-semibold'>Tracking:</strong> You may need to track both incoming and outgoing shipments...</li>
                                                <li className="text-slate-700 font-normal"><strong className='text-slate-800 font-semibold'>Customer Service:</strong> When interacting with customers, it’s important to clarify...</li>
                                                <li className="text-slate-700 font-normal"><strong className='text-slate-800 font-semibold'>Logistics Management:</strong> Managing the flow of shipments in both directions helps...</li>
                                            </ul>
                                        </section>

                                        <section>
                                            <h2 className="text-lg font-semibold mb-2">Summary</h2>
                                            <ul className="list-disc pl-6 space-y-2">
                                                <li className="text-slate-700 font-normal"><strong className='text-slate-800 font-semibold'>To Me:</strong> Refers to shipments sent to you from another sender.</li>
                                                <li className="text-slate-700 font-normal"><strong className='text-slate-800 font-semibold'>From Me:</strong> Refers to shipments you send to another recipient.</li>
                                            </ul>
                                        </section>
                                    </div>
                                </div>

                                <div className="lg:col-span-3 space-y-3 w-full">
                                    <div className="flex space-x-5">
                                        <button
                                            className={` ${activeButton === 'Bike Parcel' ? 'bg-slate-900 text-white px-3 py-1 rounded-lg font-semibold' : 'font-semibold text-gray-400 '}`}
                                            onClick={() => setActiveButton('Bike Parcel')}
                                        >
                                            Bike Parcel
                                        </button>
                                        <button
                                            className={` ${activeButton === 'To me' ? 'bg-slate-900 text-white px-3 py-1 rounded-lg font-semibold' : 'font-semibold text-gray-400 '}`}
                                            onClick={() => {
                                                setActiveButton('To me');
                                                !getUser?.me?.mobile && setModalOpen(true);
                                            }}
                                        >
                                            To me
                                        </button>
                                        <button
                                            className={` ${activeButton === 'From me' ? 'bg-slate-900 text-white px-3 py-1 rounded-lg font-semibold' : 'font-semibold text-gray-400 '}`}
                                            onClick={() => {
                                                setActiveButton('From me');
                                                !getUser?.me?.mobile && setModalOpen(true);
                                            }}
                                        >
                                            From me
                                        </button>
                                    </div>
                                    <p className='border-b'></p>

                                    <div className="mt-4">
                                        <>
                                            <div>
                                                {loading &&
                                                    <div className='my-20'>
                                                        <SpinLoader classNamecolor='true' />
                                                    </div>}
                                                {

                                                    orderData?.length > 0 && orderData &&
                                                    orderData.map((data, index) => {
                                                        const pickupDetails = {
                                                            lat: data?.data?.pickup_details?.address?.lat,
                                                            lng: data?.data?.pickup_details?.address?.lng,
                                                        };

                                                        const dropDetails = {
                                                            lat: data?.data?.drop_details?.address?.lat,
                                                            lng: data?.data?.drop_details?.address?.lng,
                                                        };
                                                        return (
                                                            <>

                                                                {
                                                                    <div key={index} className='p-5 md:grid md:grid-cols-2 grid-cols-1 mb-2 border border-slate-300 rounded-lg cursor-pointer'>
                                                                        <div className='space-y-4'>
                                                                            <p className={`text-md flex ${data?.trackStatus === 'Courier Cancelled' ? 'text-red-600' : 'text-green-600'}  font-semibold`}>
                                                                                <MdDirectionsBike className='text-2xl me-2 drop-shadow-xl' />
                                                                                {data?.trackStatus}
                                                                            </p>
                                                                            <div className='flex space-x-4'>
                                                                                <div className='space-y-1 text-gray-400'>
                                                                                    <GoCircle />
                                                                                    <ul className='ms-1.5'>
                                                                                        <li className='text-xs leading-3'>I</li>
                                                                                        <li className='text-xs leading-3'>I</li>
                                                                                        <li className='text-xs leading-3'>I</li>
                                                                                        <li className='text-xs leading-3'>I</li>
                                                                                        <li className='text-xs leading-3'>I</li>
                                                                                        <li className='text-xs leading-3'>I</li>
                                                                                        <li className='text-xs leading-3'>I</li>
                                                                                        <li className='text-xs leading-3 sm:hidden'>I</li>
                                                                                        <li className='text-xs leading-3 sm:hidden'>I</li>
                                                                                    </ul>
                                                                                    <SlLocationPin />
                                                                                </div>
                                                                                <Link to='/singlebikeorder' state={{ id: data?.id, activeButton: activeButton }}><div className='space-y-4 text-ellipsis overflow-hidden'>
                                                                                    <div>
                                                                                        <p className='text-sm font-semibold mb-1'>
                                                                                            {data?.data?.pickup_details?.address?.contact_details?.name}
                                                                                            <span className='ms-1 text-gray-400'>(Pickup)</span>
                                                                                        </p>
                                                                                        <div>
                                                                                            <p className='text-sm'>
                                                                                                {data?.data?.pickup_details?.address?.street_address1}
                                                                                            </p>
                                                                                            {/* <p className='text-sm'>
                                                                                                surat. gujrat - 787878
                                                                                            </p> */}
                                                                                        </div>

                                                                                        <p className='text-sm text-gray-500'>  {data?.data?.pickup_details?.address?.contact_details?.phone_number}</p>
                                                                                    </div>
                                                                                    <div>
                                                                                        <p className='text-sm font-semibold mb-1'>
                                                                                            {data?.data?.drop_details?.address?.contact_details?.name}
                                                                                            <span className='ms-1 text-gray-400'>(Delivery)</span>
                                                                                        </p>
                                                                                        <p className='text-sm'>
                                                                                            {data?.data?.drop_details?.address?.street_address1}
                                                                                        </p>
                                                                                        {/* <p className='text-sm'>
                                                                                            surat. gujrat - 68765
                                                                                        </p> */}
                                                                                        <p className='text-sm text-gray-500'>{data?.data?.drop_details?.address?.contact_details?.phone_number}</p>
                                                                                    </div>
                                                                                </div>
                                                                                </Link>

                                                                            </div>
                                                                            <div className='flex space-x-2'>
                                                                                <p className='text-md font-bold text-slate-800'>Total Amount ₹{Math.round(data?.order_amount)}</p>
                                                                            </div>
                                                                            <p className='text-sm text-gray-500'>{moment(data?.createdAt).format('DD/MM/YYYY')}</p>
                                                                        </div>
                                                                        <div className='md:justify-self-end md:text-end mt-6 md:mt-0 space-y-6'>
                                                                            <div className='md:justify-end'>
                                                                                <div className="flex flex-col md:flex-row md:space-x-4 space-y-4 md:space-y-0 md:justify-end">
                                                                                    {/* {data?.awb_number && */}


                                                                                    <div className=' content-center'>
                                                                                        <p className='text-sm md:justify-end flex '>AWB NO : <span className='font-semibold ms-1'> {data?.order_id}</span>
                                                                                            <MdContentCopy
                                                                                                onClick={() => { handleCopy(data?.order_id, index) }}
                                                                                                className="ml-1.5 text-lg text-blue-500"
                                                                                            >
                                                                                            </MdContentCopy>
                                                                                        </p>
                                                                                        {copySuccess[index] && (
                                                                                            <p className="text-green-500 text-sm">Copied to clipboard!</p>
                                                                                        )}
                                                                                    </div>

                                                                                    <Link to='/singlebikeorder' state={{ id: data?.id, activeButton: activeButton }}>
                                                                                        <button
                                                                                            type="button"
                                                                                            // className="rounded-md px-3 py-1.5 text-sm font-semibold text-white bg-slate-900 hover:bg-slate-900 hover:text-white"
                                                                                            className={`rounded-md px-3 py-1.5 text-sm font-semibold text-white ${data?.trackStatus === 'Courier Cancelled' ? 'bg-red-600' : 'bg-green-600'}`}
                                                                                        >
                                                                                            Track now & More Details
                                                                                        </button>
                                                                                    </Link>
                                                                                </div>
                                                                            </div>

                                                                            {/* <img  ref={mapRef}className='rounded-xl h-60 ' /> */}
                                                                            <MapWithRoute
                                                                                pickupDetails={pickupDetails}
                                                                                dropDetails={dropDetails}
                                                                                googleMapsApiKey="AIzaSyDpEuwbvnz8Aokf6wuwNBBi9kilDW6AJQA"
                                                                                style={{ width: '900px', height: '500px' }} // Adjust the width and height as needed
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </>
                                                        )
                                                    })}
                                                {data?.getOrdersforSameDay?.count === 0 &&
                                                    <div className='my-20'>
                                                        <NoDataFound />
                                                    </div>}
                                            </div>
                                        </>
                                    </div>
                                    {data?.getOrdersforSameDay?.count > 0 && (
                                        <CustomPagination
                                            totalItems={data?.getOrdersforSameDay?.count || 0} // Total number of items
                                            limit={limit}
                                            pageNo={page} // Current page number (zero-based index)
                                            handlePageClick={handlePageClick} // Handler to change page
                                        />)}
                                    <div className='lg:hidden py-3 bg-slate-50 rounded-lg px-4 cursor-pointer'>
                                        <section className="mb-8">
                                            <h2 className="text-lg font-semibold mb-2">"To Me"</h2>
                                            <p className="mb-4 text-slate-700 font-normal">
                                                <strong className='text-slate-800 font-semibold'>Meaning:</strong> When a shipment is labeled "To Me," it means that the shipment is being sent to you.
                                                Someone else (the sender) has created an order or package and is shipping it to your address.
                                            </p>
                                            <p className="mb-4 text-slate-700 font-normal">
                                                <strong className='text-slate-800 font-semibold'>Example:</strong> If you order a product online and the seller sends the package to your home or office,
                                                that shipment is "To Me." You are the recipient of the Shipment.
                                            </p>
                                        </section>

                                        <section className="mb-8">
                                            <h2 className="text-lg font-semibold mb-2">"From Me"</h2>
                                            <p className="mb-4 text-slate-700 font-normal">
                                                <strong className='text-slate-800 font-semibold'>Meaning:</strong> When a shipment is labeled "From Me," it means that you are the one sending the shipment
                                                to someone else. You create the order, prepare the package, and arrange for the Shipment to deliver it to the recipient.
                                            </p>
                                            <p className="mb-4 text-slate-700 font-normal">
                                                <strong className='text-slate-800 font-semibold'>Example:</strong> If you need to send a document to a client or a package to a friend, you create the
                                                shipment, label it, and the Shipment delivers it to the recipient. In this case, the shipment is "From Me."
                                            </p>
                                        </section>

                                        <section className="mb-8">
                                            <h2 className="text-lg font-semibold mb-2">Application in a Shipment Business</h2>
                                            <ul className="list-disc pl-6 space-y-2">
                                                <li className="text-slate-700 font-normal"><strong className='text-slate-800 font-semibold'>Tracking:</strong> You may need to track both incoming and outgoing shipments...</li>
                                                <li className="text-slate-700 font-normal"><strong className='text-slate-800 font-semibold'>Customer Service:</strong> When interacting with customers, it’s important to clarify...</li>
                                                <li className="text-slate-700 font-normal"><strong className='text-slate-800 font-semibold'>Logistics Management:</strong> Managing the flow of shipments in both directions helps...</li>
                                            </ul>
                                        </section>

                                        <section>
                                            <h2 className="text-lg font-semibold mb-2">Summary</h2>
                                            <ul className="list-disc pl-6 space-y-2">
                                                <li className="text-slate-700 font-normal"><strong className='text-slate-800 font-semibold'>To Me:</strong> Refers to shipments sent to you from another sender.</li>
                                                <li className="text-slate-700 font-normal"><strong className='text-slate-800 font-semibold'>From Me:</strong> Refers to shipments you send to another recipient.</li>
                                            </ul>
                                        </section>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </main>
                </div>

            </div>
            <Footer />
        </div>
    )
}

export default BikeAllOrder
